import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";

export default function PublicSite() {
  const { slug } = useParams();
  const nav = useNavigate();
  const [state, setState] = useState("loading");
  const [site, setSite] = useState(null);

  useEffect(() => {
    api.get(`/sites/by-slug/${slug}`)
      .then((r) => { setSite(r.data); setState("ok"); })
      .catch(() => setState("notfound"));
  }, [slug]);

  useEffect(() => {
    if (state !== "ok" || !site) return;
    document.title = site.title || slug;
    const seo = site.seo || {};
    const set = (name, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute("name", name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    set("description", seo.meta_description);
    set("keywords", seo.meta_keywords);
    if (seo.noindex) set("robots", "noindex, nofollow");
  }, [state, site, slug]);

  useEffect(() => {
    if (state === "notfound") {
      const t = setTimeout(() => nav("/404-page", { replace: true }), 0);
      return () => clearTimeout(t);
    }
  }, [state, nav]);

  if (state === "loading")
    return <div className="min-h-screen grid place-items-center text-slate-400 bg-white">Yükleniyor...</div>;

  if (state === "notfound")
    return (
      <div className="min-h-screen grid place-items-center bg-background text-center px-4">
        <div>
          <h1 className="font-display text-5xl font-extrabold text-slate-900 dark:text-white">404</h1>
          <p className="text-slate-500 mt-2">"/{slug}" sayfası bulunamadı</p>
          <a href="/" className="inline-block mt-6 px-6 py-2.5 rounded-lg bg-blue-600 text-white font-medium">Anasayfaya dön</a>
        </div>
      </div>
    );

  return (
    <div data-testid="public-site" dangerouslySetInnerHTML={{ __html: site.html }} />
  );
}
